export default defineAppConfig({
  ui: {
    primary: 'like-green',
    gray: 'cool',

    notifications: {
      // Show toasts at the top right of the screen
      position: 'top-0 bottom-auto'
    }
  }
})
